<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<crucible-dialog
  [dialogTitle]="data && data.collection && data.collection.id ? 'Edit Collection' : 'New Collection'"
  [form]="form"
  submitLabel="Save"
  [submitDisabled]="!errorFree() || !form.dirty"
  [guardUnsavedWork]="form.dirty"
  (submit)="handleEditComplete(true)"
  (cancel)="handleEditComplete(false)"
>
  @if (!!data && data.collection !== undefined && data.collection !== null) {
    <div crucibleDialogContent>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input type="text" matInput [formControl]="collectionNameFormControl" placeholder="Name (required)"
              (blur)="saveCollection('name')" value="{{data.collection.name}}">
            @if (collectionNameFormControl.hasError('required')) {
            <mat-error>
              Name is <strong>required</strong>
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Description</mat-label>
            <textarea matInput placeholder="Description" [formControl]="descriptionFormControl"
              (blur)="saveCollection('description')" value="{{data.collection.description}}"></textarea>
            @if (descriptionFormControl.hasError('required')) {
            <mat-error>
              Description is <strong>required</strong>
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </div>
  }
</crucible-dialog>
